function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { PartnersHostMessageType } from './partnersHostInboundMessages';
import { Constants } from '../utils/constants';
import { SpzaInstrumentService } from '../services/telemetry/spza/spzaInstrument';
import { logger } from '@src/logger';
/*
  Handle messages sent from partners view(iframe).
 */ export class InboundMessagesHandler {
    constructor(validOrigin, callbacksHandlers){
        _define_property(this, "active", false);
        _define_property(this, "validOrigin", void 0);
        _define_property(this, "callbacksHandlers", void 0);
        _define_property(this, "startHandleInboundMessages", ()=>{
            if (!this.active) {
                this.active = true;
                window.addEventListener('message', this.handleMessage);
            }
        });
        _define_property(this, "stopHandleInboundMessages", ()=>{
            this.active = false;
            window.removeEventListener('message', this.handleMessage);
        });
        _define_property(this, "handleMessage", (e)=>{
            // Invalid origin, do nothing.
            if (e.origin.indexOf(this.validOrigin) === -1) {
                return;
            }
            const message = JSON.parse(e.data);
            if (message.messageType === PartnersHostMessageType.Ready) {
                this.callbacksHandlers.onPartnersViewReady();
            } else if (message.messageType === PartnersHostMessageType.Login) {
                this.callbacksHandlers.onLoginRequest();
            } else if (message.messageType === PartnersHostMessageType.ChangeUrlGallery) {
                const changeUrlGalleryMessage = message;
                this.callbacksHandlers.onChangeUrlGalleryRequest(changeUrlGalleryMessage.galleryFilter, changeUrlGalleryMessage.contact, changeUrlGalleryMessage.replaceUrl);
            } else if (message.messageType === PartnersHostMessageType.StoreFilterLocation) {
                const storeFilterLocation = message;
                this.callbacksHandlers.onStoreFilterLocationRequest(storeFilterLocation.filterLocation);
            } else if (message.messageType === PartnersHostMessageType.StoreContactDetails) {
                const storeContactDetails = message;
                this.callbacksHandlers.onStoreContactDetailsRequest(storeContactDetails.contactDetails);
            } else if (message.messageType === PartnersHostMessageType.ChangeUrlDetails) {
                const chnageUrlDetailsMessage = message;
                this.callbacksHandlers.onChangeUrlDetailsRequest(chnageUrlDetailsMessage.partnerId, chnageUrlDetailsMessage.tab, chnageUrlDetailsMessage.contact, chnageUrlDetailsMessage.replaceUrl);
            } else if (message.messageType === PartnersHostMessageType.ContentHeightChange) {
                this.callbacksHandlers.onContentHeightChanged(message.height);
            } else {
                this.logWarningTelemetry('InboundMessagesHandler warning - unknown message type ' + message.messageType);
            }
        });
        _define_property(this, "logWarningTelemetry", (details)=>{
            const payload = {
                page: window && window.location ? window.location.href : '',
                action: Constants.Telemetry.Action.PartnerMessageListener,
                actionModifier: Constants.Telemetry.ActionModifier.Warning,
                details: details
            };
            SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
            logger.warning(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier
            });
        });
        this.validOrigin = validOrigin;
        this.callbacksHandlers = callbacksHandlers;
    }
}
